import React, { useState, useEffect, useRef } from "react";
import axios from "axios";
import {
  Box,
  Typography,
  TextField,
  Button,
  Grid,
  Paper,
  Avatar,
  IconButton,
  CircularProgress,
  Snackbar,
  Container,
  FormControl,
  LinearProgress,
} from "@mui/material";
import { styled } from "@mui/material/styles";
import CameraAltIcon from "@mui/icons-material/CameraAlt";
import DriveFileRenameOutlineIcon from "@mui/icons-material/DriveFileRenameOutline";
import { useTranslation } from "react-i18next";
import bg_profile from "../../assets/img/bg_profile.svg";
import SmartHireLoader from "components/Loading/SmartHireLoader";
import { useSnackbar } from "hooks/useSbackbar";

const ProfileCard = styled(Paper)(({ theme }) => ({
  padding: theme.spacing(3),
  backgroundColor: "#fff",
  borderRadius: "15px",
  boxShadow: "0 4px 50px #0000001A",
  width: "80%",
  margin: "0 auto",
  maxWidth: "1200px",
}));

const ProfileImageContainer = styled(Box)({
  position: "relative",
  display: "flex",
  alignItems: "center",
});

const StyledTextField = styled(TextField)(({ theme, isediting }) => ({
  "& .MuiOutlinedInput-root": {
    height: 56,
    borderRadius: "10px",
    fontFamily: "Poppins",
    borderColor: "#00000033",
    backgroundColor: "#fff",
    ...(isediting === "true" && {
      "& .MuiOutlinedInput-notchedOutline": {
        borderColor: "#e0e0e0",
      },
      "&:hover .MuiOutlinedInput-notchedOutline": {
        borderColor: "transparent",
        borderWidth: "2px",
        boxShadow: "0px 0px 5px 0.4px #E700C8",
      },
      "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
        borderColor: "transparent",
        borderWidth: "2px",
        boxShadow: "0px 0px 5px 0.4px #E700C8",
      },
    }),
    ...(isediting === "false" && {
      backgroundColor: "#fff",
      "& .MuiOutlinedInput-notchedOutline": {
        borderColor: "#00000033",
      },
      "&:hover .MuiOutlinedInput-notchedOutline": {
        borderColor: "#00000033",
      },
      "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
        borderColor: "transparent",
      },
    }),
  },
}));

const StyledTextArea = styled(TextField)(({ theme, isediting }) => ({
  "& .MuiOutlinedInput-root": {
    borderRadius: "10px",
    backgroundColor: isediting === "false" ? "#f5f5f5" : "#fff",
    ...(isediting === "true" && {
      "& .MuiOutlinedInput-notchedOutline": {
        borderColor: "#e0e0e0",
      },
      "&:hover .MuiOutlinedInput-notchedOutline": {
        borderColor: "transparent",
        borderWidth: "2px",
        boxShadow: "0px 0px 5px 0.4px #E700C8",
      },
      "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
        borderColor: "transparent",
        borderWidth: "2px",
        boxShadow: "0px 0px 5px 0.4px #E700C8",
      },
    }),
    ...(isediting === "false" && {
      backgroundColor: "#fff",
      "& .MuiOutlinedInput-notchedOutline": {
        borderColor: "#00000033",
      },
      "&:hover .MuiOutlinedInput-notchedOutline": {
        borderColor: "#00000033",
      },
      "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
        borderColor: "transparent",
      },
    }),
    "&.Mui-disabled": {
      backgroundColor: "#fff",
    },
  },
  "& .MuiInputBase-inputMultiline": {
    padding: "16px",
    lineHeight: "1.5",
    fontSize: "1rem",
    color: "#333",
  },
}));

const StyledTypography = styled(Typography)(() => ({
  fontFamily: "Poppins",
  color: "#00000066",
  opacity: "80%",
  fontSize: "14px",
}));

const UpdateButton = styled(Button)(({ theme }) => ({
  backgroundColor: "#fff",
  color: "#004F98",
  boxShadow: "0px 0px 13px 4px rgba(0, 0, 0, 0.1)",
  "&:hover": {
    backgroundColor: "#0085FF",
    color: "#fff",
  },
}));

const ScoreCard = styled(Paper)(({ theme }) => ({
  padding: theme.spacing(2),
  backgroundColor: "#fff",
  borderRadius: "15px",
  boxShadow: "0 4px 20px rgba(0, 0, 0, 0.08)",
  minWidth: "200px",
  border: "1px solid #f0f0f0",
}));

// const CircularProgressWithLabel = ({ value, size = 70 }) => {
//   // Determine color based on completion percentage
//   const getProgressColor = (percentage) => {
//     if (percentage < 40) return "#FF4444"; // Red
//     if (percentage < 80) return "#FF8C00"; // Orange
//     return "#22C55E"; // Green
//   };

//   const progressColor = getProgressColor(value);

//   return (
//     <Box 
//       sx={{ 
//         position: "relative", 
//         display: "inline-flex",
//         alignItems: "center",
//         justifyContent: "center"
//       }}
//     >
//       {/* Background circle */}
//       <CircularProgress
//         variant="determinate"
//         value={100}
//         size={size}
//         thickness={4}
//         sx={{
//           color: "#f0f0f0",
//           position: "absolute",
//         }}
//       />
//       {/* Progress circle */}
//       <CircularProgress
//         variant="determinate"
//         value={value}
//         size={size}
//         thickness={4}
//         sx={{
//           color: progressColor,
//           position: "absolute",
//         }}
//       />
//       {/* Percentage text in center */}
//       <Box
//         sx={{
//           position: "absolute",
//           top: "50%",
//           left: "50%",
//           transform: "translate(-50%, -50%)",
//           display: "flex",
//           alignItems: "center",
//           justifyContent: "center",
//           width: "100%",
//           height: "100%",
//           zIndex: 1,
//         }}
//       >
//         <Typography
//           variant="h6"
//           component="div"
//           sx={{
//             fontSize: "18px",
//             fontWeight: 700,
//             fontFamily: "Poppins",
//             color: progressColor,
//             textAlign: "center",
//             lineHeight: 1,
//           }}
//         >
//           {`${Math.round(value)}%`}
//         </Typography>
//       </Box>
//     </Box>
//   );
// };

const CompanyProfile = ({  }) => {
  const [formData, setFormData] = useState({
    name: "",
    country: "",
    city: "",
    postal_code: "",
    address: "",
    comp_industry: "",
    site_url:"",
    comp_description: "",
    company_logo: "",
    
  });
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [isEditing, setIsEditing] = useState(false);
  const [pendingImageFile, setPendingImageFile] = useState(null);
  const [previewImageUrl, setPreviewImageUrl] = useState(null);
  const apiUrl = process.env.REACT_APP_API_URL;
  const { t } = useTranslation();
  const fileInputRef = useRef(null);
  const { showSnackbar } = useSnackbar();

  // Calculate completion percentage
  const calculateCompletionPercentage = () => {
    const fieldsToCheck = [
      'name', 'country', 'city', 'address', 'comp_industry', 
      'site_url', 'comp_description', 'company_logo'
    ];
    
    const filledFields = fieldsToCheck.filter(field => {
      const value = formData[field];
      if (field === 'company_logo') {
        return value || previewImageUrl;
      }
      return value && value.toString().trim() !== '';
    });
    
    return Math.round((filledFields.length / fieldsToCheck.length) * 100);
  };

  function getUserIdFromAccessToken() {
    const accessToken = localStorage.getItem("accessToken");
    if (!accessToken) {
      console.error("No access token found in local storage");
      return null;
    }

    try {
      const decodedToken = parseJwt(accessToken);
      const userId = decodedToken.user_id;
      return userId;
    } catch (error) {
      console.error("Failed to decode access token", error);
      return null;
    }
  }

  function parseJwt(token) {
    const base64Url = token.split(".")[1];
    const base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/");
    const jsonPayload = decodeURIComponent(
      atob(base64)
        .split("")
        .map(function (c) {
          return "%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2);
        })
        .join("")
    );

    return JSON.parse(jsonPayload);
  }

  const userId = getUserIdFromAccessToken();

  useEffect(() => {
    fetchCompanyData();
  }, []);

  const fetchCompanyData = async () => {
    try {
      setLoading(true);
      const response = await axios.get(
        `${apiUrl}authentication/companies/${userId}/`,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
          },
        }
      );
      console.log("response.data212", response.data.data);
      const { id, image, ...filteredData } = response.data.data;
      setFormData({
        ...filteredData
      });
      setLoading(false);
    } catch (err) {
      setError(t("general.error"));
      setLoading(false);
    }
  };
  const updateCompanyData = async () => {
    try {
      setLoading(true);
      let updatedFormData = { ...formData };
      
      // Upload image if there's a pending file
      if (pendingImageFile) {
        console.log("🔄 STEP 1: Uploading image to Cloudinary FIRST...");
        console.log("Uploading pending image file:", pendingImageFile.name);
        
        // CRITICAL: Upload image and wait for completion before proceeding
        const uploadedImageUrl = await uploadImageToCloudinary(pendingImageFile);
        
        // MANDATORY: Assign the uploaded URL to company_logo field
        updatedFormData.company_logo = uploadedImageUrl;
        console.log("✅ STEP 1 COMPLETE: Image uploaded successfully:", uploadedImageUrl);
        console.log("✅ company_logo field updated:", updatedFormData.company_logo);
        
        // Clean up preview URL and pending file after successful upload
        if (previewImageUrl) {
          URL.revokeObjectURL(previewImageUrl);
          setPreviewImageUrl(null);
        }
        setPendingImageFile(null);
      }
      
      console.log("🔄 STEP 2: Sending data to API with updated company_logo...");
      console.log("Final formData being sent:", updatedFormData);
      
      const response = await axios.put(
        `${apiUrl}authentication/companies/${userId}/`,
        updatedFormData,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
          },
        }
      );
      
      console.log("✅ STEP 2 COMPLETE: Company data updated:", response.data.data);
      const { id, image, ...filteredData } = response.data.data;
      setFormData({
        ...filteredData
      });
      
      // STEP 3: Update admin data in parent component (for navbar) if image was uploaded
      if (updatedFormData.company_logo ) {
        console.log("🔄 STEP 3: Updating navbar with new data...");
   
        console.log("✅ STEP 3 COMPLETE: Navbar updated");
      }
   
      
      // Show success message only after everything is complete
      if (pendingImageFile && updatedFormData.company_logo) {
        showSnackbar(t("companyProfile.snackbarMessage") || "Company data and image updated successfully!", "success");
      } else if (pendingImageFile && !updatedFormData.company_logo) {
        showSnackbar("Company data updated successfully, but image upload failed", "warning");
      } else {
        showSnackbar(t("companyProfile.snackbarMessage") || "Company data updated successfully!", "success");
      }
      
      setLoading(false);
    } catch (err) {
      console.error("Error updating company data:", err);
      
      // Show error message only after operation is complete
      if (pendingImageFile) {
        showSnackbar(t("general.error") || "Error updating company data and image", "error");
      } else {
        showSnackbar(t("general.error") || "Error updating company data", "error");
      }
      
      setError(t("general.error"));
      setLoading(false);
    }
  };

  useEffect(() => {
    console.log("companyFormData", formData);
  }, [formData]);

  // Cleanup preview URL when component unmounts
  useEffect(() => {
    return () => {
      if (previewImageUrl) {
        URL.revokeObjectURL(previewImageUrl);
      }
    };
  }, [previewImageUrl]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const handleImageUpload = (event) => {
    const file = event.target.files[0];
    if (!file) return;
    console.log("Image selected:", file.name);
    // Store the file for later upload during updateCompanyData
    setPendingImageFile(file);
    console.log("Preview URL created215:", pendingImageFile);
    // Create preview URL for immediate display
    const previewUrl = URL.createObjectURL(file);
    setPreviewImageUrl(previewUrl);
    console.log("Preview URL created:", previewImageUrl);
    console.log("Image selected for upload:", file.name);
    // No snackbar notification - will show result after updateCompanyData completes
  };

  const uploadImageToCloudinary = async (file) => {
    const formDataUpload = new FormData();
    formDataUpload.append("file", file);
    formDataUpload.append("upload_preset", process.env.REACT_APP_PRESET_KEY);

    const response = await fetch(
      `https://api.cloudinary.com/v1_1/${process.env.REACT_APP_CLOUD_NAME}/image/upload`,
      {
        method: "POST",
        body: formDataUpload,
      }
    );
    const data = await response.json();
    console.log("Image uploaded to Cloudinary:", data.secure_url);
    return data.secure_url;
  };

  const handleImageClick = () => fileInputRef.current.click();

  const handleEdit = async () => {
    // await updateCompanyData();
    setIsEditing(true);
  };

  const handleEditCompany = async () => {
    try {
      setLoading(true);
      console.log("formData pendingImageFile sent:", pendingImageFile);
       if (pendingImageFile) {
        console.log("Uploading pending image file:", pendingImageFile.name);
        
        // CRITICAL: Upload image and wait for completion before proceeding
        const uploadedImageUrl = await uploadImageToCloudinary(pendingImageFile);
        
        // MANDATORY: Assign the uploaded URL to company_logo field
        formData.company_logo = uploadedImageUrl;
        console.log("✅ STEP 1 COMPLETE: Image uploaded successfully:", uploadedImageUrl);
        console.log("✅ company_logo field updated:", formData.company_logo);
        
        // Clean up preview URL and pending file after successful upload
        if (previewImageUrl) {
          URL.revokeObjectURL(previewImageUrl);
          setPreviewImageUrl(null);
        }
        setPendingImageFile(null);
      }
      console.log("formData being sent2020:", formData);
      const response = await axios.put(`${apiUrl}authentication/companies/${userId}/`, {
        
        ...formData,
      }, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
        },
      });
      
      showSnackbar(t("companyProfile.snackbarMessage") || "Company profile updated successfully!", "success");
      
      console.log('✅ Company profile updated successfully, updating navbar...');
      // Update admin data in parent component (for navbar)
   
      setIsEditing(false);
      setLoading(false);
    } catch (err) {
      console.error('Error saving company profile:', err);
      showSnackbar(t("general.error") || "Error updating company profile", "error");
      setError(t("general.error"));
      setLoading(false);
    }
  };

  if (error) {
    return <Typography color="error">{error}</Typography>;
  }

  return (
    <>
      <Box sx={{ position: "relative", width: "100%" }}>
        {/* Background Container */}
        <Box
          sx={{
            position: "relative",
            minHeight: "80px",
            overflow: "hidden",
            backgroundImage: `url(${bg_profile})`,
            backgroundRepeat: "no-repeat",
            backgroundSize: "cover",
            backgroundPosition: "center",
          }}
        ></Box>

        {/* Content Container */}
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            width: "100%",
            position: "relative",
            marginTop: "-100px",
          }}
        >
          {/* Profile Info Container */}
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              gap: 2,
              marginTop: "25px",
              width: "80%",
              maxWidth: "1200px",
              px: { xs: "16px", md: "1%" },
              pb: "2%",
            }}
          >
            {/* Left side - Profile Image and Text */}
            <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
              <Box position="relative">
                <Box
                  sx={{
                    width: "200px",
                    height: "200px",
                    border: "8px solid white",
                    borderRadius: "50%",
                    overflow: "hidden",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    backgroundColor: 'linear-gradient(135deg, rgba(0, 23, 231, 0.5) -54.69%, rgba(255, 204, 248, 0.5) 66.41%)',
                  }}
                >
                  {(previewImageUrl || formData.company_logo) ? (
                    <img
                      src={previewImageUrl || formData.company_logo}
                      alt={formData.name || "Company Logo"}
                      style={{
                        maxWidth: "140%",
                        maxHeight: "140%",
                        objectFit: "contain",
                        transform: "scale(0.8)",
                      }}
                    />
                  ) : (
                    <Typography
                      sx={{
                        fontSize: "48px",
                        fontWeight: "bold",
                        color: "#020060",
                      }}
                    >
                      {formData.name?.charAt(0)?.toUpperCase() || "C"}
                    </Typography>
                  )}
                </Box>
              {isEditing && <IconButton
                  onClick={handleImageClick}
                  sx={{
                    position: "absolute",
                    bottom: 12,
                    right: 15,
                    backgroundColor: "rgba(255, 255, 255, 0.1)",
                    backdropFilter: "blur(4px)",
                    boxShadow: "0 2px 8px rgba(0, 0, 0, 0.15)",
                    "&:hover": {
                      backgroundColor: "#f5f5f5",
                    },
                  }}
                >
                  <CameraAltIcon sx={{ fontSize: 20 }} />
                </IconButton>}
                
                <input
                  type="file"
                  ref={fileInputRef}
                  hidden
                  accept="image/*"
                  onChange={handleImageUpload}
                />
              </Box>

              {/* Text Content */}
              <ProfileImageContainer>
                <Box sx={{ pt: 6 }}>
                  <Typography
                    variant="h5"
                    sx={{
                      color: "#000000",
                      fontFamily: 'Poppins',
                      fontWeight: 600,
                      fontSize: '32px',
                    }}
                  >
                    {formData.name}
                  </Typography>
                  <Typography
                    variant="body1"
                    color="text.secondary"
                    sx={{
                      color: "#00000066",
                      fontSize: "18px",
                      fontFamily: "Poppins",
                    }}
                  >
                    {formData.comp_industry || "Technology Company"}
                  </Typography>
                </Box>
              </ProfileImageContainer>
            </Box>

            {/* Right side - Score Bar */}
            {/* {!loading && (
              <Box sx={{ display: "flex", alignItems: "center" }}>
                <CircularProgressWithLabel
                  value={calculateCompletionPercentage()}
                  size={70}
                />
              </Box>
            )} */}
          </Box>
        </Box>
      </Box>

      {loading ? (
        <Box 
          sx={{ 
            display: "flex", 
            justifyContent: "center", 
            alignItems: "center",
            p: 3,
            position: "fixed",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            backgroundColor: "rgba(255, 255, 255, 0.8)",
            backdropFilter: "blur(8px)",
            WebkitBackdropFilter: "blur(8px)",
            zIndex: 9999,
          }}
        >
          <SmartHireLoader />
        </Box>
      ) : (
        <>

        <ProfileCard elevation={0}>
          {/* Profile Header */}
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "flex-start",
              mb: 4,
            }}
          >
            <Typography
              variant="h6"
              sx={{
                fontSize: "22px",
                color: "#1a237e",
                fontWeight: 700,
                textTransform: "none",
              }}
            >
              {t("companyProfile.title") || "Company Profile"}
            </Typography>

            <Button
              variant="outlined"
              onClick={handleEdit}
              disabled={isEditing}
              sx={{
                py: 1,
                border: "none",
                borderRadius: "10px",
                textTransform: "none",
                borderColor: "#e0e0e0",
                color: "#004F98",
                boxShadow: "0px 4px 50px 0px #0000001A",
                mx: 1, // 8px horizontal margin as per specification
                "&:hover": {
                  border: "none",
                  backgroundColor: "rgba(26, 35, 126, 0.04)",
                },
              }}
            >
              {t("companyProfile.editButton") || "Edit"} <DriveFileRenameOutlineIcon />
            </Button>
          </Box>

          {/* Form Fields */}
          <Grid
            container
            columnSpacing={5}
            rowSpacing={6}
            sx={{
              pl: 5,
              pr: 5,
            }}
          >
            {Object.entries(formData)
              .filter(([key]) => key !== "company_logo" && key !== "created_by_admin" && key !== "comp_description" && key !== "postal_code")
              .map(([key, value]) => (
                <Grid item xs={12} md={4} key={key}>
                  <FormControl fullWidth>
                    <StyledTypography
                      sx={{ color: "grey", opacity: "80%", fontSize: "14px" }}
                    >
                      {t(`companyProfile.fields.${key}`) || key.replace(/_/g, ' ').replace(/\b\w/g, l => l.toUpperCase())}
                    </StyledTypography>
                    <StyledTextField
                      fullWidth
                      name={key}
                      value={value || ""}
                      onChange={handleChange}
                      disabled={!isEditing}
                      variant="outlined"
                      isediting={isEditing.toString()}
                    />
                  </FormControl>
                </Grid>
              ))}
            
            {/* Company Description Field - Always Last */}
            {formData.comp_description !== undefined && (
              <Grid item xs={12} key="comp_description">
                <FormControl fullWidth>
                  <StyledTypography
                    sx={{ color: "grey", opacity: "80%", fontSize: "14px" }}
                  >
                    {t(`companyProfile.fields.comp_description`) || "Company Description"}
                  </StyledTypography>
                  <StyledTextArea
                    fullWidth
                    multiline
                    rows={6}
                    name="comp_description"
                    value={formData.comp_description || ""}
                    onChange={handleChange}
                    disabled={!isEditing}
                    variant="outlined"
                    isediting={isEditing.toString()}
                  />
                </FormControl>
              </Grid>
            )}
          </Grid>

          {/* Update Button */}
          <Box sx={{ display: "flex", justifyContent: "flex-end", mt: 4 }}>
            <UpdateButton
              variant="contained"
              onClick={handleEditCompany}
              disabled={!isEditing || loading}
              sx={{
                bgcolor: "#fff",
                color: "#004F98",
                borderRadius: "10px",
                textTransform: "none",
                fontFamily: "Poppins",
                px: 4,
                py: 1,
                fontWeight: "500px",
                "&:hover": {
                  bgcolor: "#0085FF",
                },
                "&.Mui-disabled": {
                  bgcolor: "#e0e0e0",
                },
              }}
            >
              {loading ? (
                <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                  <CircularProgress size={20} color="inherit" />
                  <span>{t("companyProfile.updating") || "Updating..."}</span>
                </Box>
              ) : (
                t("companyProfile.updateButton") || "Update Company"
              )}
            </UpdateButton>
          </Box>
        </ProfileCard>
        </>
      )}
    </>
  );
};

export default CompanyProfile;